<template>
  <div class="home detail-actions-page">
    <div class="px-8 py-4">
      <!-- Header -->
      <div class="detail-page-header mb-4">
        <button type="button" class="btn btn-link text-decoration-none detail-page-back" @click="$router.go(-1)" style="padding: 10px 0">
          <AppIcon name="bi-arrow-left" class="bi bi-arrow-left me-2" />{{$t('back')}}
        </button>
        <div class="detail-page-title-row d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <h3 class="detail-page-title mb-0">{{ delivery.reference }}</h3>
          <div class="detail-page-actions">
            <button v-if="delivery.status != 'draft'" @click="ViewDelivery()" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
              <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
              {{$t('view')}}
            </button>
            <button v-if="helper.checkAccess('edit_supplier_returns') != -1" @click="editRow()" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs detail-page-action--secondary">
              <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
              {{$t('edit')}}
            </button>
            <button v-if="helper.checkAccess('delete_supplier_returns') != -1" @click="deleteRow()" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs detail-page-action--danger">
              <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
              {{$t('delete')}}
            </button>
            <div v-if="delivery.status != 'draft' && helper.checkAccess('create_supplier_invoices') > 0" class="btn-group" role="group">
              <button class="btn btn-primary btn-xs dropdown-toggle" type="button" id="dropdownMenuButton1" style="padding: 5px;margin: 0;font-size: 12px !important;" data-bs-toggle="dropdown" aria-expanded="false">
                <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right" style="font-size:12px" /> {{$t('transfert')}}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" style="cursor:pointer" @click="transferInvoice()">{{$t('invoice')}}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="text-center" style="padding:2rem">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Return Info -->
      <div v-else-if="delivery && delivery.id">
        <!-- Tabs -->
        <ul class="nav nav-tabs detail-page-tabs mb-4">
          <li class="nav-item">
            <a class="nav-link" :class="{active: step === 'overview'}" @click="step = 'overview'">{{$t('overview')}}</a>
          </li>
          <li class="nav-item" v-if="helper.checkAccess('view_attachments') != -1">
            <a class="nav-link" :class="{active: step === 'attachments'}" @click="step = 'attachments'">{{$t('attachments')}}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{active: step === 'history'}" @click="step = 'history'">{{$t('history')}}</a>
          </li>
        </ul>

        <!-- Tab Content -->
        <!-- Overview Tab -->
        <div v-if="step === 'overview'">
          <div class="row">
            <!-- Left Column: Return Details -->
            <div class="col-md-8">
              <div class="card mb-4">
                <div class="card-header bg-white">
                  <h6 class="mb-0"><AppIcon name="bi-arrow-return-left" class="bi bi-arrow-return-left me-2" />{{$t('return')}} {{$t('information')}}</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <small class="text-muted d-block">{{$t('reference')}}</small>
                      <strong>{{delivery.reference}}</strong>
                    </div>
                    <div class="col-md-6 mb-3">
                      <small class="text-muted d-block">{{$t('date')}}</small>
                      <strong>{{formatDate(delivery.date)}}</strong>
                    </div>
                    <div class="col-md-6 mb-3">
                      <small class="text-muted d-block">{{$t('created_by')}}</small>
                      <strong>{{delivery.user ? delivery.user.name : '-'}}</strong>
                    </div>
                    <div class="col-md-6 mb-3">
                      <small class="text-muted d-block">{{$t('created_at')}}</small>
                      <strong>{{formatDate(delivery.created_at)}}</strong>
                    </div>
                    <div class="col-md-6 mb-3">
                      <small class="text-muted d-block">{{$t('updated_at')}}</small>
                      <strong>{{formatDate(delivery.updated_at)}}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Products Card -->
              <div class="card mb-4">
                <div class="card-header bg-white">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="mb-0"><AppIcon name="bi-box-seam" class="bi bi-box-seam me-2" />{{$t('products')}}</h6>
                    <div>
                        <button v-if="delivery.status != 'draft' && !reorderMode" @click="toggleReorder" style="padding: 2px 8px; font-size: 12px !important;" class="btn btn-outline-secondary btn-sm">
                            <AppIcon name="bi-arrow-down-up" class="bi bi-arrow-down-up me-1" style="font-size:12px" />
                            {{$t('reorder')}}
                        </button>
                        <div v-if="reorderMode" class="btn-group" role="group">
                            <button @click="saveOrder" style="padding: 2px 8px; font-size: 12px !important;" class="btn btn-success btn-sm">
                                <AppIcon name="bi-check" class="bi bi-check me-1" style="font-size:12px" /> {{$t('save')}}
                            </button>
                            <button @click="toggleReorder" style="padding: 2px 8px; font-size: 12px !important;" class="btn btn-danger btn-sm">
                                <AppIcon name="bi-x" class="bi bi-x me-1" style="font-size:12px" /> {{$t('cancel')}}
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive">
                  <table class="table mb-0 table-striped small">
                    <thead>
                      <tr class="text-secondary">
                        <th>{{$t('product_label')}}</th>
                        <th>{{$t('quantity')}}</th>
                        <th v-if="reorderMode" style="width: 100px;">{{$t('actions')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(product, index) in delivery.products" :key="product.id">
                        <td><div class="product-rich-text" v-html="sanitizeRichText(product.product_label)"></div></td>
                        <td>{{product.quantity}}</td>
                        <td v-if="reorderMode">
                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary btn-sm" @click="moveUp(index)" :disabled="index === 0" style="padding: 2px 5px;"><AppIcon name="bi-arrow-up-short" class="bi bi-arrow-up-short" /></button>
                                <button type="button" class="btn btn-outline-secondary btn-sm" @click="moveDown(index)" :disabled="index === delivery.products.length - 1" style="padding: 2px 5px;"><AppIcon name="bi-arrow-down-short" class="bi bi-arrow-down-short" /></button>
                            </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Notes Card -->
              <div v-if="delivery.notes" class="card">
                <div class="card-header bg-white">
                  <h6 class="mb-0"><AppIcon name="bi-sticky" class="bi bi-sticky me-2" />{{$t('notes')}}</h6>
                </div>
                <div class="card-body">
                  <p class="mb-0">{{ delivery.notes }}</p>
                </div>
              </div>
            </div>

            <!-- Right Column: Supplier Info -->
            <div class="col-md-4">
              <div class="card">
                <div class="card-header bg-white">
                  <h6 class="mb-0"><AppIcon name="bi-building" class="bi bi-building me-2" />{{$t('supplier')}}</h6>
                </div>
                <div class="card-body">
                  <div v-if="!delivery.supplier" class="text-muted">{{$t('no_supplier_found')}}</div>
                  <div v-else>
                    <div class="mb-3">
                      <small class="text-muted d-block">{{$t('reference')}}</small>
                      <strong>{{delivery?.supplier?.reference}}</strong>
                    </div>
                    <div class="mb-3">
                      <small class="text-muted d-block">{{$t('name')}}</small>
                      <strong>{{delivery?.supplier?.name}}</strong>
                    </div>
                    <div class="mb-3">
                      <small class="text-muted d-block">{{$t('phone')}}</small>
                      <strong>{{delivery?.supplier?.phone || '-'}}</strong>
                    </div>
                    <div>
                      <small class="text-muted d-block">{{$t('email')}}</small>
                      <strong>{{delivery?.supplier?.email || '-'}}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Other Tabs -->
        <div v-if="step === 'attachments' && helper.checkAccess('view_attachments') != -1">
          <attachments v-if="delivery && delivery.id" :entity_id="delivery.id" entity_type="return" />
        </div>

        <div v-if="step === 'history'">
          <document-history
            :history="history"
            :loading="loadingHistory"
            :pagination="historyPagination"
            @pageChange="changeHistoryPage"
          />
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <add-edit-return-modal 
        v-if="editModalisOpen" 
        @modalClosed="editModalisOpen = false" 
        modalId="edit-return-modal-01" 
        :isModalOpen="editModalisOpen"  
        :data="delivery" 
        action="update" 
    ></add-edit-return-modal>
    <!-- Edit modal -->

    <!-- quote modal -->
    <invoice-template-modal 
        v-if="invoiceModalisOpen" 
        @modalClosed="invoiceModalisOpen = false" 
        modalId="invoice-return-modal-01" 
        :isModalOpen="invoiceModalisOpen"  
        :data="delivery" 
        type="return">
    </invoice-template-modal>
    <!-- quote modal -->
    
    <!-- create Modal -->
    <add-edit-credit-invoice-modal 
        v-if="createCreditInvoiceModalState" 
        @modalClosed="createCreditInvoiceModalState = false"
        modalId="create-credit-invoice-modal-01" 
        :isModalOpen="createCreditInvoiceModalState" 
        :data="delivery" 
        action="transfer"
    ></add-edit-credit-invoice-modal>
    <!-- create modal -->
  </div>
</template>

<script>
// @ is an alias to /src
import helper from '../../helper'
import moment from 'moment'
import attachments from '../../components/Attachment.vue'
import AddEditReturnModal from '../../components/returnSupplier/AddEditReturnModal.vue';
import AddEditCreditInvoiceModal from '../../components/creditInvoice/AddEditInvoiceModal';
import InvoiceTemplateModal from '../../components/invoiceLayout/InvoiceTemplateModal';
import DocumentHistory from '../../components/DocumentHistory.vue'

export default {
  name: 'ReturnDetails',
  components :{
    attachments,
    AddEditReturnModal,
    AddEditCreditInvoiceModal,
    InvoiceTemplateModal,
    DocumentHistory
  },
  data(){
    return {
        loading : false,
        loadingHistory : false,
        delivery : {},
        history : [],
        historyPagination : {
            count: 0,
            per_page: 10,
            current_page: 1,
            total_pages: 1
        },
        amount_paid : 0,
        step : 'overview',
        total_purchases : 0,
        total_quote : 0,
        invoiceModalisOpen : false,
        invoiceModal : null,
        editModal : null,
        editModalisOpen : false,
        createClientState : false,
        createCreditInvoiceModalState : false,
        reorderMode: false,
        originalProductsOrder: null
    }
  },
  created(){
    if(!this.$route.params || !this.$route.params.id) return this.$route.push('/deliveries')
    this.getDelivery(this.$route.params.id)
  },
  mounted(){
    window.mixpanel.track("supplier_return_details");

    if(helper.checkAccess('view_supplier_returns') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_supplier_returns') == -2) return this.$router.push({path : '/subscribe'})

  },
  methods : {
        sanitizeRichText(value){
            return helper.sanitizeRichText(value)
        },
         ViewDelivery(){
            this.invoiceData = this.delivery 
            this.invoiceModalisOpen = true;
        },
        async getDelivery(id){
            try{
                this.loading = true
                const response = await helper.customGet(`${process.env.VUE_APP_API}/supplier-returns/${id}`)
                this.delivery = response.data
                this.loading = false
                
            }catch(error){
                this.$router.push({path : '/supplier-returns'})
                this.loading = false
            }
        },
        async getDeliveryHistory(id){
            try{
                this.loadingHistory = true
                const response = await helper.customGet(`${process.env.VUE_APP_API}/supplier-returns/${id}/history`)
                this.history = response.data.data || response.data
                this.historyPagination = {
                    count: response.data.count || 0,
                    per_page: response.data.per_page || 10,
                    current_page: response.data.current_page || 1,
                    total_pages: response.data.total_pages || 1
                }
                this.loadingHistory = false
            }catch(error){
                alert('Error fetching history:', error)
                this.loadingHistory = false
            }
        },
        async changeHistoryPage(page){
            if(page < 1 || page > this.historyPagination.total_pages) return;
            
            try{
                this.loadingHistory = true
                const response = await helper.customGet(`${process.env.VUE_APP_API}/supplier-returns/${this.delivery.id}/history?page=${page}&per_page=${this.historyPagination.per_page}`)
                this.history = response.data.data || response.data
                this.historyPagination = {
                    count: response.data.count || 0,
                    per_page: response.data.per_page || 10,
                    current_page: response.data.current_page || 1,
                    total_pages: response.data.total_pages || 1
                }
                this.loadingHistory = false
            }catch(error){
                alert('Error fetching history page:', error)
                this.loadingHistory = false
            }
        },
        editRow(){
            // this.clearForm()
            this.editModalisOpen = true
            this.delivery.date = moment(this.delivery.date).format('YYYY-MM-DD')
        },
        async transferInvoice(){
            this.delivery.total = this.delivery.products && this.delivery.products.length ? this.delivery.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
            this.createCreditInvoiceModalState = !this.createCreditInvoiceModalState
        },
        async deleteRow(){
            this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/supplier-returns/${this.delivery.id}`)
                    this.$router.push({path : '/supplier-returns'})
                }
            })
        },
        createCreditInvoiceModal(data){
          this.createCreditInvoiceModalState = data
        },
        formatReference(number,id) { return helper.formatReference(number,id);},
        formatDate(date) { return helper.formatDate(date) },
        formatMoney(number) { return helper.formatMoney(number);},
        toggleReorder() {
            if (!this.reorderMode) {
                // Enter reorder mode: save current order to restore if cancelled
                this.originalProductsOrder = JSON.parse(JSON.stringify(this.delivery.products));
                this.reorderMode = true;
            } else {
                // Cancel reorder mode: restore original order
                this.delivery.products = this.originalProductsOrder;
                this.reorderMode = false;
                this.originalProductsOrder = null;
            }
        },
        moveUp(index) {
            if (index > 0) {
                const products = [...this.delivery.products];
                const temp = products[index];
                products[index] = products[index - 1];
                products[index - 1] = temp;
                this.delivery.products = products;
            }
        },
        moveDown(index) {
            if (index < this.delivery.products.length - 1) {
                const products = [...this.delivery.products];
                const temp = products[index];
                products[index] = products[index + 1];
                products[index + 1] = temp;
                this.delivery.products = products;
            }
        },
        async saveOrder() {
            try {
                this.loading = true;
                
                const products = this.delivery.products.map((p, index) => {
                    return {
                        inventory_id: p.inventory_id,
                        product_id: p.product_id,
                        product_label: p.product_label,
                        quantity: String(p.quantity),
                        price: String(p.price),
                        unity: p.unity,
                        purchase_price: String(p.purchase_price),
                        vat: p.vat,
                        total: p.total,
                        sub_total: p.sub_total,
                        custom_product: !!p.custom_product,
                        discount: p.discount,
                        position: index
                    }
                })

                await helper.customPatch(`${process.env.VUE_APP_API}/supplier-returns/${this.delivery.id}`, {
                    reference: this.delivery.reference,
                    date: this.delivery.date,
                    supplier_id: this.delivery.supplier_id,
                    invoice_id: this.delivery.invoice_id,
                    purchase_id: this.delivery.purchase_id,
                    notes: this.delivery.notes,
                    status: this.delivery.status,
                    products: products
                });

                this.loading = false;
                this.reorderMode = false;
                this.originalProductsOrder = null;
                
                this.$toast.open({
                    message: this.$t('updated_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
                
                // Refresh data
                this.getDelivery(this.$route.params.id);
                
            } catch (error) {
                this.loading = false;
                this.$toast.open({
                    message: error.response?.data?.message || this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            }
        }
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    helper(){ return helper},
    total(){ return this.delivery.products.length ? this.delivery.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.delivery.products.length ? this.delivery.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0}
  },
  watch : {
        editModalisOpen(newValue) {
            if(newValue === false){
                this.getDelivery(this.$route.params.id)
            }
        },
        step(newValue) {
            if(newValue === 'history' && this.delivery.id){
                this.getDeliveryHistory(this.delivery.id)
            }
        }
    }
}
</script>

<style scoped>
    .product-rich-text::v-deep > :last-child {
        margin-bottom: 0 !important;
    }

    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
